import { render, staticRenderFns } from "./BaselineDashboard.vue?vue&type=template&id=572d16b1"
import script from "./BaselineDashboard.vue?vue&type=script&lang=js"
export * from "./BaselineDashboard.vue?vue&type=script&lang=js"
import style0 from "./BaselineDashboard.vue?vue&type=style&index=0&id=572d16b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports